import Axios from "axios";

const api = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  async (config: any) => {
    // Não sobrescrever Content-Type para uploads (multipart/form-data)
    if (config.data instanceof FormData) {
      config.headers = {
        ...config.headers,
        Accept: "application/json",
      };
      delete config.headers["Content-Type"];
    } else {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        Accept: "application/json",
      };
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

export default api;
